import { get } from 'lodash';

import * as RefundApi from '@/api/bill/refund';
import actionTypes from './actionType';

const setRefundSource = (source) => {
  return {
    type: actionTypes.SET_REFUND_SOURCE,
    payload: {
      refundSource: source,
    },
  };
};

const toggleRefundDrawerVisible = (visible) => {
  return {
    type: actionTypes.TOGGLE_REFUND_DRAWER_VISIBLE,
    payload: {
      refundDrawerVisible: visible,
    },
  };
};

const setRefundInfoLoading = (loading) => {
  return {
    type: actionTypes.SET_REFUND_INFO_LOADING,
    payload: {
      refundInfoLoading: loading,
    },
  };
};

const initRefundInfo = (params) => {
  return async (dispatch) => {
    dispatch(setRefundInfoLoading(true));
    try {
      const res = await RefundApi.fetchRefundInfo(params);
      dispatch(setRefundInfoLoading(false));
      dispatch({
        type: actionTypes.FETCH_REFUND_INFO,
        payload: {
          refundInfo: {
            roomRate: get(res, 'data.roomRate', []),
            deposit: get(res, 'data.deposit', []),
          },
        },
      });
    } catch (err) {
      dispatch(setRefundInfoLoading(false));
    }
  };
};

const updateRefundInfo = (params) => {
  const { refundInfo } = params;
  return (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_REFUND_INFO,
      payload: {
        refundInfo,
      },
    });
  };
};

export { setRefundSource, toggleRefundDrawerVisible, initRefundInfo, updateRefundInfo };
